import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ScanLine, Package, Search } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import EntregaRopa from './components/EntregaRopa';
import ConsultaEstado from './components/ConsultaEstado';

const AutoServicioPage = () => {
  return (
    <div className="container mx-auto p-6 space-y-6">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-2xl">
              <ScanLine className="h-7 w-7 text-primary" />
              AutoServicio - Gestión de Prendas
            </CardTitle>
            <CardDescription>
              Sistema de autoservicio para empleados: entrega de prendas y consulta de estado
            </CardDescription>
          </CardHeader>
        </Card>
      </motion.div>

      {/* Tabs */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.1 }}
      >
         <EntregaRopa />
{/*         <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="grid w-full grid-cols-2 mb-6">
            <TabsTrigger value="entrega" className="flex items-center gap-2">
              <Package className="h-4 w-4" />
              Entregar Ropa
            </TabsTrigger>
            <TabsTrigger value="consulta" className="flex items-center gap-2">
              <Search className="h-4 w-4" />
              Consultar Estado
            </TabsTrigger>
          </TabsList>

          <TabsContent value="entrega">
            <EntregaRopa />
          </TabsContent>

          <TabsContent value="consulta">
            <ConsultaEstado />
          </TabsContent>
        </Tabs> */}
      </motion.div>
    </div>
  );
};

export default AutoServicioPage;
